export default __webpack_public_path__ + "static/media/LivenceHome.cdd48da1.png";